import React from "react";
import { arrayOf, shape } from "prop-types";

import InfoTooltip from "components/tooltips/Info";
import { ModalActionProps, RevenueSplit } from "types";
import BaseTable from "../Base";
import ColumnHeader from "../ColumnHeader";
import RevenueSplitRow from "./Row";

function RevenueSplitsTable({ revenueSplits, modalActionProps, ...props }) {
  function renderRows() {
    return revenueSplits.map((revenueSplit) => (
      <RevenueSplitRow
        revenueSplit={revenueSplit}
        modalActionProps={modalActionProps}
      />
    ));
  }

  return (
    <BaseTable {...props}>
      <thead>
        <tr>
          <ColumnHeader>User</ColumnHeader>
          <ColumnHeader>
            Split %&nbsp;
            <InfoTooltip text="The received portion (after platform fee) will be split accordingly." />
          </ColumnHeader>
        </tr>
      </thead>
      <tbody>{renderRows()}</tbody>
    </BaseTable>
  );
}

RevenueSplitsTable.propTypes = {
  // The registration tier that we're showing the split for.
  revenueSplits: arrayOf(shape(RevenueSplit)).isRequired,

  // Properties passed down from the parent modal which go to the action button.
  modalActionProps: ModalActionProps.isRequired,
};

export default RevenueSplitsTable;
